export const CATEGORY_BLURBS = {
	"laptopuri-tabelete-telefoane": {
		ro: "Laptopuri, tablete și telefoane pentru muncă, studiu și viața de zi cu zi.",
		en: "Laptops, tablets and phones for work, study and everyday life.",
		de: "Laptops, Tablets und Telefone für Arbeit, Studium und den Alltag.",
		fr: "Ordinateurs portables, tablettes et téléphones pour le travail, les études et la vie quotidienne.",
		it: "Laptop, tablet e telefoni per lavoro, studio e vita quotidiana.",
	},
	"pc-periferice-software": {
		ro: "Componente PC, periferice și software pentru gaming sau productivitate.",
		en: "PC components, peripherals and software for gaming or productivity.",
		de: "PC-Komponenten, Peripheriegeräte und Software für Gaming oder Produktivität.",
		fr: "Composants PC, périphériques et logiciels pour le gaming ou la productivité.",
		it: "Componenti PC, periferiche e software per gaming o produttività.",
	},
	"tv-audio-video-foto": {
		ro: "Televizoare, echipamente audio-video și foto, pentru divertisment la calitate superioară.",
		en: "TVs, audio-video and photo equipment for top-quality entertainment.",
		de: "Fernseher, Audio-/Video- und Fotogeräte für erstklassige Unterhaltung.",
		fr: "Téléviseurs, équipements audio-vidéo et photo pour un divertissement de haute qualité.",
		it: "TV, apparecchiature audio-video e foto per un intrattenimento di alta qualità.",
	},
	"electrocaznice-climatizare": {
		ro: "Electrocasnice și sisteme de climatizare pentru un cămin confortabil în orice sezon.",
		en: "Appliances and climate control systems for a comfortable home all year round.",
		de: "Haushaltsgeräte und Klimasysteme für ein komfortables Zuhause in jeder Jahreszeit.",
		fr: "Électroménager et systèmes de climatisation pour un foyer confortable en toute saison.",
		it: "Elettrodomestici e sistemi di climatizzazione per una casa confortevole in ogni stagione.",
	},
	bacanie: {
		ro: "Produse alimentare de bază, livrate rapid direct la ușa ta.",
		en: "Everyday grocery staples, delivered fast to your door.",
		de: "Grundlegende Lebensmittel, schnell direkt vor deine Haustür geliefert.",
		fr: "Produits alimentaires essentiels, livrés rapidement chez vous.",
		it: "Generi alimentari di base, consegnati rapidamente a casa tua.",
	},
	"pet-shop": {
		ro: "Hrană, accesorii și produse de îngrijire pentru câini, pisici și alte animale de companie.",
		en: "Food, accessories and care products for dogs, cats and other pets.",
		de: "Futter, Zubehör und Pflegeprodukte für Hunde, Katzen und andere Haustiere.",
		fr: "Nourriture, accessoires et produits de soin pour chiens, chats et autres animaux de compagnie.",
		it: "Cibo, accessori e prodotti di cura per cani, gatti e altri animali domestici.",
	},
	"ingrijire-personala-si-cosmetice": {
		ro: "Produse de îngrijire personală și cosmetice pentru rutina ta zilnică.",
		en: "Personal care and cosmetic products for your daily routine.",
		de: "Körperpflege- und Kosmetikprodukte für deine tägliche Routine.",
		fr: "Produits de soin personnel et cosmétiques pour votre routine quotidienne.",
		it: "Prodotti per la cura personale e cosmetici per la tua routine quotidiana.",
	},
	"casa-gradina-si-bricolaj": {
		ro: "Unelte, decorațiuni și produse pentru casă, grădină și proiecte de bricolaj.",
		en: "Tools, decor and products for home, garden and DIY projects.",
		de: "Werkzeuge, Dekoration und Produkte für Haus, Garten und Heimwerkerprojekte.",
		fr: "Outils, décoration et produits pour la maison, le jardin et le bricolage.",
		it: "Utensili, decorazioni e prodotti per casa, giardino e fai da te.",
	},
	"sport-si-travel": {
		ro: "Echipamente sportive și accesorii de călătorie pentru un stil de viață activ.",
		en: "Sports equipment and travel accessories for an active lifestyle.",
		de: "Sportausrüstung und Reisezubehör für einen aktiven Lebensstil.",
		fr: "Équipements sportifs et accessoires de voyage pour un mode de vie actif.",
		it: "Attrezzatura sportiva e accessori da viaggio per uno stile di vita attivo.",
	},
	"auto-moto": {
		ro: "Piese, accesorii și echipamente auto-moto pentru întreținere și personalizare.",
		en: "Parts, accessories and equipment for car and motorcycle maintenance and customization.",
		de: "Teile, Zubehör und Ausrüstung für Auto und Motorrad – für Wartung und Individualisierung.",
		fr: "Pièces, accessoires et équipements auto-moto pour l'entretien et la personnalisation.",
		it: "Ricambi, accessori ed equipaggiamenti auto-moto per manutenzione e personalizzazione.",
	},
	"jucarii-copii-bebe": {
		ro: "Jucării și articole pentru copii și bebeluși, alese pentru siguranță și calitate.",
		en: "Toys and items for children and babies, chosen for safety and quality.",
		de: "Spielzeug und Artikel für Kinder und Babys, ausgewählt für Sicherheit und Qualität.",
		fr: "Jouets et articles pour enfants et bébés, choisis pour leur sécurité et leur qualité.",
		it: "Giocattoli e articoli per bambini e neonati, scelti per sicurezza e qualità.",
	},
	"birotica-si-papetarie": {
		ro: "Articole de birou și papetărie pentru școală, birou sau uz personal.",
		en: "Office and stationery supplies for school, office or personal use.",
		de: "Büro- und Schreibwaren für Schule, Büro oder den persönlichen Gebrauch.",
		fr: "Fournitures de bureau et papeterie pour l'école, le bureau ou un usage personnel.",
		it: "Articoli per ufficio e cancelleria per scuola, ufficio o uso personale.",
	},
	cadouri: {
		ro: "Idei de cadouri pentru orice ocazie, pentru cei dragi ție.",
		en: "Gift ideas for every occasion, for your loved ones.",
		de: "Geschenkideen für jeden Anlass, für deine Liebsten.",
		fr: "Idées cadeaux pour toutes les occasions, pour vos proches.",
		it: "Idee regalo per ogni occasione, per le persone a cui tieni.",
	},
	autoaparare: {
		ro: "Produse de autoapărare pentru siguranța ta și a celor apropiați.",
		en: "Self-defense products for your safety and that of your loved ones.",
		de: "Selbstverteidigungsprodukte für deine Sicherheit und die deiner Liebsten.",
		fr: "Produits d'autodéfense pour votre sécurité et celle de vos proches.",
		it: "Prodotti di autodifesa per la tua sicurezza e quella dei tuoi cari.",
	},
	"accesorii-diverse": {
		ro: "O selecție variată de accesorii, utile în fiecare zi.",
		en: "A varied selection of accessories, useful every day.",
		de: "Eine vielfältige Auswahl an Zubehör, nützlich für jeden Tag.",
		fr: "Une sélection variée d'accessoires, utiles au quotidien.",
		it: "Una selezione varia di accessori, utili ogni giorno.",
	},
	servicii: {
		ro: "Servicii disponibile prin eMagyl.Ro pentru nevoile tale curente.",
		en: "Services available through eMagyl.Ro for your everyday needs.",
		de: "Dienstleistungen über eMagyl.Ro für deinen täglichen Bedarf.",
		fr: "Services disponibles via eMagyl.Ro pour vos besoins quotidiens.",
		it: "Servizi disponibili tramite eMagyl.Ro per le tue esigenze quotidiane.",
	},
};

export function getCategoryBlurb(slug, locale) {
	const entry = CATEGORY_BLURBS[slug];
	if (!entry) return null;
	return entry[locale] || entry.ro;
}
